export default __webpack_public_path__ + "static/media/custom-orders-collapse-active.73818742.svg";